export enum MenuEvent {
    Edit = 1,
    SoftDelete = 2,
    HardDelete = 3
}